import { projects as entries } from '@/content/projects';
import { ProjectEntry } from '@/content/schema';
import { useCredits } from './credits';

const projects = ProjectEntry.array().parse(entries);

export function ProjectsPanel() {
  const credits = useCredits();
  return (
    <div className="lens-panel projects">
      <div className="lens-bar">
        <span className="lens-dot" />
        <span>projects</span>
      </div>
      <ul className="project-grid">
        {projects.map((p) => (
          <li key={p.name} className="project-card">
            <h3>
              {p.url ? (
                <a href={p.url} target="_blank" rel="noreferrer">
                  {p.name}
                </a>
              ) : (
                p.name
              )}
            </h3>
            {(p.years || (p.clientVisible && p.client)) && (
              <p className="project-meta">
                {[p.years, p.clientVisible ? p.client : undefined].filter(Boolean).join(' · ')}
              </p>
            )}
            <p>{p.summary}</p>
            {p.stack.length > 0 && (
              <ul className="project-stack">
                {p.stack.map((s) => (
                  <li key={s}>{s}</li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
      <div className="contact">
        <a href="mailto:manuel.gasteiger.dev@gmail.com">manuel.gasteiger.dev@gmail.com</a>
      </div>
      <details className="credits">
        <summary>Credits</summary>
        <ul>
          {credits.map((c) => (
            <li key={c}>{c}</li>
          ))}
        </ul>
      </details>
    </div>
  );
}
